export type QuerySerializableObject = {
  [key: string]: string | boolean | number;
};
export const ordersObjectToQueryString = (key: string, object: QuerySerializableObject): string => {
  const copyObject = { ...object };
  const objectKeys = Object.keys(copyObject);
  const hasKeys = objectKeys.length > 0;
  let count = 0;
  const queryString = hasKeys
    ? objectKeys
        .map((propertyKey) => {
          if (copyObject[propertyKey] !== '' && copyObject[propertyKey] !== undefined) {
            count++;
            if (count === 1) {
              return `${key}=${propertyKey}:${copyObject[propertyKey]}`;
            }
            return `&${key}=${propertyKey}:${copyObject[propertyKey]}`;
          }
        })
        .join('')
    : '';

  return queryString;
};
